import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import mainImg from "../../../assets/images/Home/main-img.png";
import tag from "../../../assets/images/Home/tag.png";
import rocket from "../../../assets/images/Home/hammer.png";
import arrow from "../../../assets/images/Home/arrow.png";
import target from "../../../assets/images/Home/target-2.png";
import star from "../../../assets/images/Home/star.png";
import { motion } from "framer-motion";
import swal from "sweetalert";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useMediaQuery } from "react-responsive";

const HomeSection = () => {
  const [slides, setSlides] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [fooder, setFooder] = useState("");
  const [formData, setFormData] = useState({
    username: "",
    mobile: "",
    email: "",
    students_of: "test",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchHomeData();
    fetchFooterData();
  }, []);

  const fetchHomeData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/banner-list`
      );
      setSlides(res.data.data || []);
      setImagePath(res.data.imagePath);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFooterData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setFooder(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobile" && !/^\d{0,10}$/.test(value)) return;
    if (name === "username" && value.length > 50) return;
    if (name === "email" && value.length > 42) return;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};
    if (!formData.username.trim()) newErrors.username = "Full Name is required";
    if (!formData.mobile.trim()) newErrors.mobile = "Mobile number is required";
    if (formData.mobile && formData.mobile.length !== 10)
      newErrors.mobile = "Mobile number must be 10 digits";
    if (!formData.email.trim()) newErrors.email = "Email is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/book-free-counselling`,
        formData
      );

      if (res.data.success === "1") {
        swal({
          title: "Success",
          text: "Book Free Counselling Successful!",
          icon: "success",
          timer: 2000,
          buttons: false,
        });
        setFormData({ username: "", mobile: "", email: "" });
      } else {
        swal("Error", res.data.message || "Enquire failed", "error");
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error"
      );
    }
  };

  const settings = {
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
  };

  // Filter only active slides
  const activeSlides = slides.filter(
    (slide) => slide.status === "active" || slide.status === "1"
  );
  const isDesktop = useMediaQuery({ minWidth: 768 });

  return (
    <>
      {fooder.bannerpermission == 1 && activeSlides.length > 0 && (
        <Slider {...settings} className="hero-slick-slider">
          {activeSlides.map((slide, index) => {
            const bannerName = slide?.banner_name || "";
            const words = bannerName.trim().split(" ");
            const lastWord = words.pop();
            const leadingText = words.join(" ");

            return (
              <section className="hero-banner-1" key={index}>
                <div className="container">
                  <div className="content">
                    <div className="text_block">
                      <div className="row">
                        <div className="col-xl-5 col-lg-5">
                          <img src={tag} alt="Tag" className="mb-24 tag" />
                          <h4 className="mini_heading">
                            <img src={star} alt="star" className="d-inline" />
                            <span>{slide?.title?.trim() || ""}</span>
                          </h4>
                          <h1 className="mb-16 title">
                            {leadingText}{" "}
                            <span className="fm-sec">
                              {lastWord}!
                              <img
                                src={rocket}
                                alt="Rocket"
                                className="rocket"
                              />
                            </span>
                          </h1>
                          <h4 className="mb-48">
                            {slide?.sub_heading?.trim() || ""}
                          </h4>
                          <div className="btn_block">
                            <Link to="/courses" className="educate-btn">
                              <span className="educate-btn__curve"></span>
                              Explore Course
                            </Link>
                            <img src={arrow} alt="Arrow" className="arrow" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Side Image + Feature Card */}
                  <motion.div
                    className="text-end wow fadeInUp animated"
                    {...(isDesktop && {
                      initial: { opacity: 0, scale: 0.5 },
                      animate: { opacity: 1, scale: 1 },
                      transition: { duration: 1, delay: 0.35 },
                    })}
                  >
                    <div className="banner_feature_card">
                      <div className="card_block">
                        <h6 className="mb-4p">24*7 access</h6>
                        <p>Free Mocks</p>
                        <img
                          src={target}
                          alt="Target"
                          className="target_icon"
                        />
                      </div>
                    </div>
                    <img
                      src={
                        slide?.image ? `${imagePath}${slide.image}` : mainImg
                      }
                      alt="Main Banner"
                      className="main-img"
                    />
                  </motion.div>

                  {/* Contact Form */}
                  <motion.div
                    className="text-end wow fadeInUp animated"
                    {...(isDesktop && {
                      initial: { opacity: 0, scale: 0.5 },
                      animate: { opacity: 1, scale: 1 },
                      transition: { duration: 1, delay: 0.5 },
                    })}
                  >
                    <div className="talkto_form d-md-flex">
                      <div className="card p-4 shadow-sm">
                        <h2 className="text-center mb-3">
                          Book Free Counselling
                        </h2>
                        <p className="text-center my-2">
                          ENQUIRE NOW OR CALL +91-{fooder.support1_number}
                        </p>
                        <form onSubmit={handleSubmit}>
                          <div className="mb-3">
                            <label className="text-start text-dark d-block">
                              Full Name
                            </label>
                            <input
                              type="text"
                              name="username"
                              value={formData.username}
                              onChange={handleChange}
                              className={`form-control ${
                                errors.username ? "is-invalid" : ""
                              }`}
                              placeholder="Full Name"
                            />
                          </div>

                          <div className="mb-3">
                            <label className="text-start text-dark d-block">
                              Mobile
                            </label>
                            <input
                              type="text"
                              inputMode="numeric"
                              name="mobile"
                              value={formData.mobile}
                              onChange={handleChange}
                              className={`form-control ${
                                errors.mobile ? "is-invalid" : ""
                              }`}
                              placeholder="Contact Number"
                            />
                          </div>

                          <div className="mb-3">
                            <label className="text-start text-dark d-block">
                              Email
                            </label>
                            <input
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              className={`form-control ${
                                errors.email ? "is-invalid" : ""
                              }`}
                              placeholder="Email"
                            />
                          </div>

                          <div className="d-flex justify-content-start">
                            <button type="submit" className="educate-btn m-0">
                              <span className="educate-btn__curve" />
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </motion.div>
                </div>
              </section>
            );
          })}
        </Slider>
      )}
    </>
  );
};

export default HomeSection;
